export const API_BASE_URL = `https://${process.env.REACT_APP_API_URL}/api`;
